@use '../../design-tokens/typography/typography' as *;
@use '../custom-scroll/custom-scroll' as *;

@layer design-system {
  .tabContainer {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: unset;
    min-height: 38px;
    overflow: auto hidden;
    @include custom-scroll-minimal;
  }

  .tabPanel {
    width: 100%;
    height: 100%;
  }

  .header {
    width: 100%;
    border: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    transition: 0.4s;
    border-bottom: solid 1px var(--border-default);
  }

  .tab {
    display: flex;
    margin-right: 20px;

    &.tabFullWidth {
      flex: 1;
      justify-content: center;
      margin-right: 0;
    }
  }

  .iconWrapper {
    display: flex;
    align-items: center;
  }

  .tabIcon {
    transition: 0.2s;
    fill: var(--icon-default);

    &.tabIconActive {
      fill: var(--icon-primary);
    }
  }

  .badge {
    margin-left: 6px;
  }

  .tabButton {
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: inherit;
    background-color: transparent;
    padding: 8px 4px;
    margin-bottom: -1px;
    border: none;
    @include typography-emu;
    color: var(--text-default);
    border-bottom: solid 2px transparent;
    text-transform: capitalize;
    transition: 0.2s;

    &:not(:disabled):hover {
      color: var(--text-primary);

      .tabIcon {
        fill: var(--icon-primary);
      }
    }

    &:disabled {
      color: var(--text-disabled);
      cursor: default;
    }

    &.tabButtonFullWidth {
      width: 100%;
    }

    &.tabButtonActive {
      color: var(--text-primary);
      border-bottom: solid 2px var(--border-primary);
    }

    &:focus {
      outline: none;
    }
  }
}
